/**
 * 应用主入口
 * @author jasonelchen
 */
import React from 'react'
import { render } from 'react-dom'
import App from './App'

render(<App />, document.getElementById('root'))
